// Lucide icon: file (https://lucide.dev/icons/file)
import { File } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconFile = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <File />
    </IconComponentStyled>
  )
}
